import styled from 'styled-components'

export const PictureArea = styled.div`
  height: ${({ height }) => height};
  min-width: ${({ width }) => width};
  max-width: ${({ width }) => width};
  a,
  img {
    width: inherit;
  }
  img {
    object-fit: cover;
  }
`
